/**
 * Do not edit directly
 * Generated on Fri, 26 Jan 2024 09:10:52 GMT
 */

export const SbFontNameRegular = '"National2-Regular"'
export const SbFontNameMedium = '"National2-Medium"'
export const SbFontNameBold = '"National2-Bold"'
